<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	// Stores
	import { devices } from 'src/stores/lists/devices';
	// Helpers
	import { isPremiumUser } from 'src/helpers/user_helpers';
	import { getUserTimeZoneDate } from 'src/helpers/date_helper';
	// Design system components
	import { Toolbar, Breadcrumbs } from '@Shelly/shelly-design-system';
	// Components
	import ConsumptionOverallChart from './ConsumptionOverallChart.svelte';
	import ChartControls from '../Chart/ChartControls.svelte';
	import EmptyList from '../Lists/EmptyList.svelte';
	// Chart Config
	import { getOverAllChartsConfig } from '../Chart/chart_config';
	// Types
	import type { chartControlsDataInterface } from '../Chart/chart_control_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { navigateToShop } from '../Lists/list-helpers';
	import EmptyPlaceholder from '../EmptyPlaceholder.svelte';

	import { isEnergyPriceFeatureEnabled } from 'src/helpers/energy_price_helpers';
	import EnergyPriceSuggestion from './VerivoxEnergyPriceIntegration/components/suggestion/EnergyPriceSuggestion.svelte';

	let chartControlsData: chartControlsDataInterface, chartControlsElement: ChartControls;

	const chartControlsEvent = (e: CustomEvent) => {
			chartControlsData = e.detail;
		},
		onChangeEvent = (e: CustomEvent) => {
			if (e.detail.action == 'dblClick') {
				chartControlsElement.changeDateRangeOnClick(e);
			}
		},
		chartConfig = getOverAllChartsConfig('bar');

	const enabledHourControl = isPremiumUser();
</script>

<Toolbar class="mb-m">
	<Breadcrumbs
		aria-label={$format('breadcrumbs_energy_history', { default: 'Energy history' })}
		slot="breadcrumbs"
		links={[{ label: $format('tab_energy_item_history', { default: 'History' }) }]}
	/>
	<svelte:fragment slot="leftSide">
		<ChartControls
			bind:this={chartControlsElement}
			chartControlID="chart-overall-range-dp"
			overallPage={true}
			{enabledHourControl}
			timeZone={getUserTimeZoneDate()}
			on:init={chartControlsEvent}
			on:change={chartControlsEvent}
		/>
	</svelte:fragment>
</Toolbar>

{#if Object.values($devices).length === 0}
	{#if isEnergyPriceFeatureEnabled()}
		<EnergyPriceSuggestion {chartControlsData} />
	{/if}

	<div class="mt-md-m mt-sm-0 text-center d-flex flex-direction-column">
		<EmptyPlaceholder class="mt-md-l mt-sm-s mb-m" />
		<EmptyList
			title={$format('no_power_measuring_device_title', {
				default: 'No power measuring devices.',
			})}
			description={$format('get_necessary_device_to_track_usage', {
				default: 'Get the necessary devices to start tracking energy usage.',
			})}
			btnText={capFirstChar(
				$format('button_go_to_store', {
					default: 'Go to store',
				}).toLocaleLowerCase(),
			)}
			onClick={() => {
				navigateToShop();
			}}
		/>
	</div>
{:else if chartControlsData}
	<!-- Set chart history only for total account consumption chart, there is info for all rooms that have data. -->
	<ConsumptionOverallChart
		{chartConfig}
		{chartControlsData}
		reqURL={chartConfig.url}
		title={capFirstChar(
			$format('text_total_energy', {
				default: 'Total Energy',
			}),
		)}
		on:change={onChangeEvent}
	/>
{/if}
